'use client';

import React from "react";
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import StarIcon from '@mui/icons-material/Star';          // Filled star
import StarHalfIcon from '@mui/icons-material/StarHalf';  // Half star
import StarBorderIcon from '@mui/icons-material/StarBorder'; // Empty star

const Card2 = ({ data }) => {
  // Generate random rating between 3 and 5 with one decimal place
  const randomRating = (Math.random() * 2 + 3).toFixed(1);
  const rating = parseFloat(randomRating);

  const testimonial = {
    position: " ",
    rating: rating,
    social: [],
  };

const styles = {
  cardContainer: {
    width: "100%",          // Responsive width: fill parent's width
    maxWidth: "300px",      // Max width cap for consistency
    backgroundColor: "#fff",
    borderRadius: "15px",
    textAlign: "center",
    color: "#000",
    padding: "20px",
    position: "relative",
    overflow: "visible",    // prevent clipping
    fontFamily: "'Poppins', sans-serif",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    margin: "0 auto",       // center card inside container
    boxSizing: "border-box", // important for padding + border sizing
    display: "flex",
    flexDirection: "column",
    height: "100%",          // fill the wrapper height to match others
    justifyContent: "space-between",  // spread content vertically
  },
  image: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    border: "5px solid #DB2777",
    marginBottom: "15px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    objectFit: "cover",      // prevents image distortion/stretching
  },
  name: {
    fontSize: "18px",
    fontWeight: "bold",
    margin: "10px 0 5px 0",
    color: "#000",
  },
  position: {
    fontSize: "14px",
    fontStyle: "italic",
    marginBottom: "15px",
    color: "#000",
  },
  rating: {
    display: "flex",
    justifyContent: "center",
    gap: "3px",
    marginBottom: "10px",
    color: "#ffdd00",
  },
  feedback: {
    fontSize: "1rem",
    color: "#000000",
    fontFamily: "'Roboto', sans-serif",
    lineHeight: 1.625,
    margin: "0 0 10px",
    textAlign: "justify",
    whiteSpace: "normal",
    wordWrap: "break-word",   // breaks long words so card doesn't stretch
    overflowWrap: "break-word",
  },
  socialIcons: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "10px",
  },
  socialIcon: {
    fontSize: "20px",
    color: "#000",
    textDecoration: "none",
  },
};


  // Render stars with MUI icons: full, half, empty
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarIcon key={"full" + i} style={{ color: "#ffdd00" }} />);
    }

    if (hasHalfStar) {
      stars.push(<StarHalfIcon key="half" style={{ color: "#ffdd00" }} />);
    }

    for (let i = 0; i < emptyStars; i++) {
      stars.push(<StarBorderIcon key={"empty" + i} style={{ color: "#ccc" }} />);
    }

    return stars;
  };

  return (
    <div style={styles.cardContainer}>
      <img src={data.photo_url} alt={data.name} style={styles.image} />
      <div style={styles.name}>{data.name}</div>
      <div style={styles.position}>{testimonial.position}</div>
      <div style={styles.rating}>{renderStars(testimonial.rating)}</div>
      <div style={styles.feedback}>"{data.review_description}"</div>
      <div style={styles.socialIcons}>
        {testimonial.social?.map((icon, index) => (
          <a
            key={index}
            href={icon.link}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.socialIcon}
          >
            {icon.icon}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Card2;
